module.exports = __webpack_public_path__ + "static/media/design9.253c2a39.png";